{
  "rovo-agents.scenario-onboarding.backButton": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "rovo-agents.scenario-onboarding.close.no-translate": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "rovo-agents.scenario-onboarding.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "rovo-agents.scenario-onboarding.gettingStarted": [
    {
      "type": 0,
      "value": "Getting started with your agent"
    }
  ],
  "rovo-agents.scenario-onboarding.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "rovo-agents.scenario-onboarding.startTour": [
    {
      "type": 0,
      "value": "Start Tour"
    }
  ],
  "rovo-agents.scenario-onboarding.step1Body": [
    {
      "type": 0,
      "value": "Scenarios allow you to instruct your agent to do things differently depending on the situation."
    }
  ],
  "rovo-agents.scenario-onboarding.step1Headline": [
    {
      "type": 0,
      "value": "Tune your agent to each situation"
    }
  ],
  "rovo-agents.scenario-onboarding.step2Body": [
    {
      "type": 0,
      "value": "Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation."
    }
  ],
  "rovo-agents.scenario-onboarding.step2Headline": [
    {
      "type": 0,
      "value": "Set your agent's traits and goals"
    }
  ],
  "rovo-agents.scenario-onboarding.step3Body": [
    {
      "type": 0,
      "value": "You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation."
    }
  ],
  "rovo-agents.scenario-onboarding.step3Headline": [
    {
      "type": 0,
      "value": "See what your agent knows"
    }
  ],
  "rovo-agents.scenario-onboarding.step4Body": [
    {
      "type": 0,
      "value": "You can add skills to your agent's scenarios so it can connect and take action across apps."
    }
  ],
  "rovo-agents.scenario-onboarding.step4Headline": [
    {
      "type": 0,
      "value": "See what your agent can do"
    }
  ],
  "rovo-agents.scenario-onboarding.stepIndicator": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ]
}